export const ADMIN_DOCTORS_LIST_REQUEST = "ADMIN_DOCTORS_LIST_REQUEST";
export const ADMIN_DOCTORS_LIST_SUCCESS = "ADMIN_DOCTORS_LIST_SUCCESS";
export const ADMIN_DOCTORS_LIST_FAIL = "ADMIN_DOCTORS_LIST_FAIL";

export const ADMIN_DOCTOR_ADD_REQUEST = "ADMIN_DOCTOR_ADD_REQUEST";
export const ADMIN_DOCTOR_ADD_SUCCESS = "ADMIN_DOCTOR_ADD_SUCCESS";
export const ADMIN_DOCTOR_ADD_FAIL = "ADMIN_DOCTOR_ADD_FAIL";

export const ADMIN_DOCTOR_UPDATE_REQUEST = "ADMIN_DOCTOR_UPDATE_REQUEST";
export const ADMIN_DOCTOR_UPDATE_SUCCESS = "ADMIN_DOCTOR_UPDATE_SUCCESS";
export const ADMIN_DOCTOR_UPDATE_FAIL = "ADMIN_DOCTOR_UPDATE_FAIL";

export const ADMIN_DOCTOR_DELETE_REQUEST = "ADMIN_DOCTOR_DELETE_REQUEST";
export const ADMIN_DOCTOR_DELETE_SUCCESS = "ADMIN_DOCTOR_DELETE_SUCCESS";
export const ADMIN_DOCTOR_DELETE_FAIL = "ADMIN_DOCTOR_DELETE_FAIL";
